import { PropsWithChildren, useEffect, useState } from "react";
import {
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  useIonRouter,
} from "@ionic/react";
import { mobileNavItemProps } from "routes/routeData";
import { getBaseURLFromRouter } from "swing-utils";
import { filterMenuItemsForUserSubset } from "utils/helpers";
import { useAdminSecurityRestrictions } from "utils/hooks";

type MobileNavWrapperProps = {
  navItems: mobileNavItemProps[];
};

const MobileNavWrapper: React.FC<PropsWithChildren<MobileNavWrapperProps>> = ({
  children,
  navItems,
}) => {
  // eslint-disable-next-line
  const [_, setActiveTab] = useState("");
  const router = useIonRouter();
  const securityRestrictions = useAdminSecurityRestrictions();

  useEffect(() => {
    setActiveTab(
      // removes leading slash that useIonRouter provides.
      getBaseURLFromRouter(router) || navItems[0].tab,
    );
  }, [navItems, router]);

  return (
    <IonTabs onIonTabsDidChange={(e) => setActiveTab(e.detail.tab)}>
      <IonRouterOutlet animated>{children}</IonRouterOutlet>
      <IonTabBar slot="bottom">
        {navItems
          .filter((item) => filterMenuItemsForUserSubset(item, securityRestrictions))
          .map((item, index) => (
            <IonTabButton key={index} tab={item.tab} href={`/${item.tab}`}>
              <item.logo className="icon-2xl" />
              <IonLabel>{item.text}</IonLabel>
            </IonTabButton>
          ))}
      </IonTabBar>
    </IonTabs>
  );
};

export default MobileNavWrapper;
